(() => {
  const closeDetails = (navigation) => {
    navigation.querySelectorAll('details[open]').forEach((details) => {
      details.removeAttribute('open');
    });
  };

  const initialize = (navigation) => {
    if (navigation.dataset.autoCollapse === 'true') return;
    navigation.dataset.autoCollapse = 'true';

    navigation.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (link && navigation.contains(link)) {
        closeDetails(navigation);
        return;
      }

      const summary = event.target.closest('summary');
      if (!summary || !navigation.contains(summary)) return;

      const current = summary.parentElement;
      if (!current.matches('.liason-nav__item > details, .liason-nav__drawer > details')) return;
      if (current.open) return;

      navigation.querySelectorAll('.liason-nav__item > details[open], .liason-nav__drawer > details[open]').forEach((details) => {
        if (details !== current) details.removeAttribute('open');
      });
    });

    navigation.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDetails(navigation);
    });
  };

  const initializeAll = () => {
    document.querySelectorAll('.liason-nav').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.liason-nav').forEach((navigation) => {
      if (!navigation.contains(event.target)) closeDetails(navigation);
    });
  });

  const closeOutsideDrawer = (target) => {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('.liason-nav').forEach((navigation) => {
      const drawer = navigation.querySelector('.liason-nav__drawer');
      if (drawer && !drawer.contains(target)) closeDetails(navigation);
    });
  };

  let outsideTouch = null;
  document.addEventListener('touchstart', (event) => {
    const touch = event.touches[0];
    outsideTouch = touch ? { x: touch.clientX, y: touch.clientY, target: event.target } : null;
  }, { passive: true });
  document.addEventListener('touchmove', (event) => {
    const touch = event.touches[0];
    if (!touch || !outsideTouch) return;
    if (Math.hypot(touch.clientX - outsideTouch.x, touch.clientY - outsideTouch.y) > 10) {
      closeOutsideDrawer(outsideTouch.target);
      outsideTouch = null;
    }
  }, { passive: true });
  document.addEventListener('touchend', () => { outsideTouch = null; }, { passive: true });
  document.addEventListener('touchcancel', () => { outsideTouch = null; }, { passive: true });
  document.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaY) + Math.abs(event.deltaX) > 2) closeOutsideDrawer(event.target);
  }, { passive: true });

  document.addEventListener('shopify:section:load', initializeAll);
})();